export type DeviceStatus = 'connected' | 'disconnected' | 'communicating' | 'commissioned' | 'decommissioned' | 'Register' | 'CertificateAvailable' | 'DownloadComplete' | 'PublishReady' | 'Pending' | 'Failed' | 'Deregistered' | 'AdminApprovalPending' | 'AdminApproved' | 'AdminRejected';
export type DeviceStatusName = any
export type DeviceType = 'welding_device' | 'coating_device';
export type DeviceTypeName = any
export type WeldType = 'm500' | 'coating' | string; // Allow for other weld types
export const WeldTypeNames:any = {
  'm500': 'M-500',
  'p625': 'P-625',
  'p600': 'P-600',
  'p600z': 'P-600Z',
  'iwm' : 'IWM',
}
export const DeviceStatusNames:any = {
  
}

export interface Project {
  id: number;
  projectNumber?: string;
  projectName?: string;
  name?: string;
  status?: 'active' | 'completed' | 'on_hold';
  startDate: string;
  endDate?: string;
}

export interface ConnectedEquipment {
  id: string;
  name: string;
  type: string;
  model: string;
  serialNumber: string;
}

// API Response Interface
export interface DeviceApiResponse {
  id: number;
  deviceId?: string;
  status: string;
  createdAt: string;
  projectNumber: string;
  projectName: string;
  projectId: number;
  updatedAt: string;
  updatedBy: string;
  weld_uid: string | null;
  weld_type: string | null;
  connection_status: string | null;
  communication_status?: string | null;
  response_time?: string | null;
  weldMachineConnected?: boolean | null;
  EdgeFWVersion?: string | null;
  connectedEquipment?: ConnectedEquipment | null;
  ipAddress?: string | null;
  ip_address?: string | null;
  set_time: {
    data: string;
    error?: string;
  } | null;
  get_time: {
    data: string;
    error?: string;
  } | null;
  erase_logs: {
    data: string;
    error?: string;
  } | null;
  number_of_logs: {
    data: string;
    error?: string;
  } | null;
  password_protection: {
    data: string;
    error?: string;
  } | null;
  location: {
    data: string;
    error?: string;
  } | null;
  weld_parameter_logs: {
    data: string;
    error?: string;
  } | null;
  deviceData?: any;
}

export interface LocationData {
  Station: string;
  BugType: string;
  BugNum: string;
}

export interface DeviceOperation {
  data: string;
  error?: string;
  parsed?: any;
}

export interface Device {
  id: string;  // deviceId from API
  name: string; // weld_type from API
  type: DeviceType;
  status: any;//DeviceStatus;
  lastSeen: string; // updatedAt from API
  connection_status?: string; // Online/Offline status from API
  communication_status?: string; // Online/Offline status from API
  response_time?: any; // Response time from API
  weldMachineConnected?: boolean; // Weld machine connected from API
  EdgeFWVersion?: string; // Edge FW version from API
  connectedEquipment?: ConnectedEquipment;
  project?: Project;
  location?: {
    data: string; // JSON string containing LocationData
    parsed?: LocationData; // Parsed location data
  };
  set_time?: DeviceOperation;
  get_time?: DeviceOperation;
  erase_logs?: DeviceOperation;
  number_of_logs?: DeviceOperation;
  password_protection?: DeviceOperation;
  weld_parameter_logs?: DeviceOperation;
  deviceData?: any;
  metadata: {
    ipAddress?: string;
    manufacturer: string;
    model: string;
    weldType?: string;
    weldUID?: string;
    serialNumber?: string;
    installationDate: string; // createdAt from API
    firmware: string;
  };
}

export interface DeviceUpdatePayload {
  status?: DeviceStatus;
  metadata?: Partial<Device['metadata']>;
  project?: Project | null;
}

export interface DeviceBulkUpdatePayload {
  deviceIds: string[];
  update: DeviceUpdatePayload;
} 